import { ComponentSize } from '@eleventheye/asui';
import Ruler from 'components/ruler/Ruler';
import { useStatisticalAnalysis } from 'hooks/useStatisticalAnalysis';
import React, { useMemo } from 'react';
import { ITeamWeekRank } from 'types';
import TeamField from '../field/TeamField';
import styles from './Analysis.module.scss';

type AnalysisProps = {
  className?: string;
  categoryStats: ITeamWeekRank[];
};

const Analysis: React.FC<AnalysisProps> = ({ className = '', categoryStats }) => {
  const baseCls = `${styles.AnalysisContainer} ${className}`;
  const stats = useStatisticalAnalysis(categoryStats);

  const fieldProps = useMemo(
    () => ({
      labelMinWidth: 45,
      labelSize: ComponentSize.Medium,
    }),
    []
  );

  const formatValue = useMemo(
    () =>
      (value: number, decimals: number = 2): string => {
        return isNaN(value) ? '0.00' : value.toFixed(decimals);
      },
    []
  );

  if (!stats) {
    return (
      <div className={baseCls}>
        <div>No data available for statistical analysis</div>
      </div>
    );
  }

  return (
    <div className={baseCls}>
      <TeamField {...fieldProps} textLabel="MEAN/AVG" textSize={ComponentSize.Large} text={formatValue(stats.mean)} />
      <TeamField
        {...fieldProps}
        textLabel="MEAN/RSD"
        textSize={ComponentSize.Large}
        text={formatValue(stats.reducedMean)}
      />
      <TeamField {...fieldProps} textLabel="MEDIAN" text={formatValue(stats.median)} />
      <TeamField {...fieldProps} textLabel="STD DEV" text={formatValue(stats.stdDev)} />
      <TeamField {...fieldProps} textLabel="MAX" text={formatValue(stats.max)} />
      <TeamField {...fieldProps} textLabel="MIN" text={formatValue(stats.min)} />
      <Ruler style={{ width: '100%' }} className="STEEL" />
      <TeamField {...fieldProps} textLabel="RANGE" text={formatValue(stats.range)} />
      <TeamField {...fieldProps} textLabel="VARIANCE" text={formatValue(stats.variance)} />
      <TeamField {...fieldProps} textLabel="SUM" text={formatValue(stats.sum)} />
    </div>
  );
};

export default Analysis;
